import React, { FC, ReactElement } from 'react';
import {GUTTER} from "../../../constants";
import {Col, Row} from "antd";
import {
    AttemptFITPerformanceDataTableCard
} from "../components/FITFeedback/AttemptPerformanceDataTableCard";
import {FeedbackRowProps} from "./types";

export const ChecklistFeedbackRow: FC<FeedbackRowProps> = ({attemptId, style}): ReactElement => (
    <Row gutter={GUTTER} style={style}>
        <Col>
            {attemptId ? <AttemptFITPerformanceDataTableCard attemptId={attemptId}/> : null}
        </Col>
    </Row>
);
